import BlogSection from "../atoms/BlogPreview";
import ContactForm from "../atoms/ContactForm";
import ServicesHeader from "../atoms/ServicesHeader";
import Button from "../components/v2/Button";
import Input from "../components/v2/Input";
import Textarea from "../components/v2/TextArea";
import Typography from "../components/v2/Typography";
import useApp from "../hooks/useApp";

const Marketing = () => {

    const appCtx = useApp();

    return (
        <>
            <ServicesHeader active="/services/marketing-design" />
            {/* <!-- 1. HERO --> */}
            <section className="py-20 md:py-28 bg-white marketing-service">
                <div className="container mx-auto px-4 max-w-6xl grid md:grid-cols-2 gap-12 items-start">
                    <div>
                        <h1 className="text-5xl font-bold leading-tight mb-6">Marketing & Design Services</h1>
                        <p className="text-xl mb-4">A premium domain is just the start. What happens next determines its value.</p>
                        <p className="text-lg mb-6 max-w-xl">That's where <strong>StudioFX</strong>—a trusted part of the NameConnect brand—comes in. Their team specializes in web design, email marketing, and lead generation that gives domains real-world presence and momentum.</p>
                        <p className="text-lg mb-6 max-w-xl">Whether you're developing a domain into a lead engine, dressing it up for acquisition, or building a brand from scratch, StudioFX delivers fast, sharp, and scalable digital assets aligned to your goals. We work closely with their team to provide you with seamless support.</p>
                        <ul className="list-disc list-inside space-y-2 text-lg">
                            <li>Custom Website Design & Hosting</li>
                            <li>Email Verification & Cold Outreach</li>
                            <li>Landing Pages Optimized for Leads</li>
                            <li>Marketing Funnels & Conversion Copy</li>
                            <li>SEO Setup & Keyword Research</li>
                            <li>Brand Identity & Logo Design</li>
                        </ul>
                    </div>
                    {/* Callback Form */}
                    <div className="border-1 border-blue-500 p-8 shadow-sm bg-gray-50">
                        <h2 className="text-2xl font-semibold mb-4">Ask About StudioFX</h2>
                        <form onSubmit={(e) => {
                            e.preventDefault();
                            console.log(e.target);
                            appCtx.submitForm(e.target.name.value, e.target.email.value, e.target.phone.value, e.target.query.value);
                        }} className="space-y-4">
                            <div className="form-control">
                                <div className="form-name">
                                    <Typography variant="para">Name</Typography>
                                </div>
                                <Input isDark={true} name="name" label="" placeholder="John Doe" type="text" value="" onChange={() => { }} />
                            </div>
                            <div className="form-control">
                                <div className="form-name">
                                    <Typography variant="para">Phone number</Typography>
                                </div>
                                <Input isDark={true} name="phone" label="" placeholder="+1 123456789" type="number" value="" onChange={() => { }} />
                            </div>
                            <div className="form-control">
                                <div className="form-name">
                                    <Typography variant="para">Email</Typography>
                                </div>
                                <Input isDark={true} name="email" label="" placeholder="johndoe@gmail.com" type="email" value="" onChange={() => { }} />
                            </div>
                            <Textarea isDark={true} name="query" label="" placeholder="How can StudioFX help your brand?" value="" onChange={() => { }} style={{height: 170}} />
                            <Button variant="primary" type="submit" fullWidth>
                                <Typography variant="button">Submit Inquiry</Typography>
                            </Button>
                        </form>
                        <p className="text-sm mt-2">
                            Explore more at{" "}
                            <a className="underline text-blue-600" href="https://www.studiofx.com" target="_blank" rel="noopener">
                                StudioFX.com
                            </a>, or use this form to start a joint project with StudioFX and NameConnect.
                        </p>
                    </div>
                </div>
            </section>

            {/* 2. TRUSTED PARTNER */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 max-w-5xl text-center">
                    <h2 className="text-3xl font-semibold mb-6">A Trusted NameConnect Partner</h2>
                    <p className="text-lg mb-4">StudioFX works exclusively with domain investors, entrepreneurs, and companies who understand that presentation matters. As part of the extended NameConnect family, they've helped dozens of clients elevate digital properties for sale, lead generation, and launch.</p>
                    <p className="text-sm text-gray-600">For complex projects, we coordinate directly with StudioFX to ensure your digital strategy stays seamless and stress-free.</p>
                </div>
            </section>

            {/* 3. WHAT WE OFFER */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">What We Offer</h2>
                    <div className="grid md:grid-cols-2 gap-8 text-lg">
                        <div className="space-y-4">
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Brand Identity Design</h3>
                                <p>Logos, color schemes, and visuals that match your business goals.</p>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Website Design & Development</h3>
                                <p>Custom, user-friendly websites that engage visitors and convert leads.</p>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Digital Marketing</h3>
                                <p>SEO, SEM, social media, and content strategies tailored to your audience.</p>
                            </div>
                        </div>
                        <div className="space-y-4">
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Creative Campaigns</h3>
                                <p>Targeted advertising and branding campaigns to boost visibility.</p>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Budget-Friendly Solutions</h3>
                                <p>We connect you to trusted professionals who fit your financial plan.</p>
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold mb-2">Complete Digital Strategy</h3>
                                <p>From domain to brand launch—we guide you through every step of the process.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* 4. WHY WORK WITH US */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">Why Work With Us?</h2>
                    <ul className="grid md:grid-cols-2 gap-6 text-lg list-disc list-inside">
                        <li>We understand the domain space and what it takes to succeed online</li>
                        <li>We handpick marketing and design partners based on quality and cost-effectiveness</li>
                        <li>We provide guidance tailored to your business stage — startup, growing company, or established brand</li>
                        <li>We simplify the process, saving you time and helping you avoid costly mistakes</li>
                    </ul>
                </div>
            </section>

            {/* 5. STUDIOFX SERVICES */}
            <section className="py-16 bg-white">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">StudioFX Core Services</h2>
                    <div className="space-y-8 text-lg">
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Custom Website Design & Hosting</h3>
                            <p>Professional, responsive websites that showcase your domain's potential and convert visitors into customers.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Email Verification & Cold Outreach</h3>
                            <p>Targeted email campaigns that reach the right audience and generate qualified leads for your business.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Landing Pages Optimized for Leads</h3>
                            <p>High-converting landing pages designed to capture leads and maximize your domain's revenue potential.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Marketing Funnels & Conversion Copy</h3>
                            <p>Strategic funnels and persuasive copy that guide visitors through the customer journey.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">SEO Setup & Keyword Research</h3>
                            <p>Complete SEO optimization to ensure your domain ranks well and attracts organic traffic.</p>
                        </div>
                        <div>
                            <h3 className="text-2xl font-semibold mb-2">Brand Identity & Logo Design</h3>
                            <p>Professional branding that establishes credibility and makes your domain memorable.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* 6. DOMAIN TO BRAND */}
            <section className="py-16 bg-gray-50">
                <div className="container mx-auto px-4 max-w-5xl">
                    <h2 className="text-3xl font-semibold mb-6">From Domain to Brand — We Guide You Every Step</h2>
                    <p className="text-lg mb-4">Owning the perfect domain is just the beginning. Turning that domain into a strong, recognizable brand requires expert marketing and design.</p>
                    <p className="text-lg mb-6">Your domain is your foundation. Let us help you build a brand that stands out and drives results.</p>
                    <div className="bg-blue-50 p-6 rounded text-center">
                        <p className="text-xl font-medium">"StudioFX transformed our domain into a lead-generating machine. The ROI exceeded our expectations."<br /><span className="text-sm">— Domain Investor & Entrepreneur</span></p>
                    </div>
                </div>
            </section>

            {/* 7. CTA */}
            <section className="py-20 bg-blue-600 text-white text-center">
                <div className="container mx-auto px-4 max-w-4xl">
                    <h2 className="text-4xl font-bold mb-4">Take Your Domain to the Next Level</h2>
                    <p className="text-lg mb-8">Contact NameConnect today to explore marketing and design options that fit your vision and budget.</p>
                    <div className="space-x-4">
                        <a href="https://www.studiofx.com" target="_blank" rel="noopener" className="inline-block bg-white text-blue-600 font-semibold py-4 px-8 rounded">Visit StudioFX.com</a>
                        <a href="/contact" className="inline-block bg-blue-800 text-white font-semibold py-4 px-8 rounded border-2 border-white">Start Your Project</a>
                    </div>
                </div>
            </section>

            <BlogSection />
        </>
    );
};

export default Marketing;